/**
 * Pure H OS · Phase D Wave 3 · Knowledge Base (types + live view).
 * MongoDB collection: `pureh_knowledge`.
 */
import { liveArray } from "../services/store";

export type KnowledgeKind = "guide" | "SOP" | "policy" | "FAQ";

export type KnowledgeArticle = {
  id: string;
  title: string;
  kind: KnowledgeKind;
  category: string;
  author: string;
  updatedRelative: string;
  views: number;
  tags: string[];
  summary: string;
  body?: string;
};

export const KNOWLEDGE: KnowledgeArticle[] = liveArray<KnowledgeArticle>("knowledge");
